export default "__VITE_ASSET__a15ccb47__"